import { styled } from '@mui/system'
import Typography from '../../../../atoms/typography'

const Link = styled(Typography)`
	color: ${({ theme }) => theme.palette.grey.main};
	margin-bottom: 32px;
	cursor: pointer;
	display: inline-block;
	text-decoration: underline;
`

const Title = styled(Typography)`
	font-size: ${({ theme }) => theme.typography.pxToRem(28)};
	margin-bottom: 32px;
	padding: 0 16px;
	${({ theme }) => theme.breakpoints.up('sm')} {
		padding: 0;
		font-size: ${({ theme }) => theme.typography.pxToRem(32)};
	}
`
const SubTitle = styled(Typography)`
	color: ${({ theme }) => theme.palette.grey.main};
	margin-bottom: 9px;
	padding: 0 16px;
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin-bottom: 32px;
		padding: 0;
	}
`
export { Link, Title, SubTitle }
